import React, { useEffect, useState, useRef } from 'react';
import { GallerySimpleImage } from '$partials/media';
import GalleryVideo from '$partials/media/gallery-video.jsx';
import MediaGallery, { MediaGalleryProvider, MediaGalleryContext } from '$partials/global/media-gallery.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').RichText}
 */

const RichText = ({
    text,
}) => {

    return (
        <div className='module-article-block theme-light bg-main-background py-24 sm:py-40 md:py-48'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='col-wrapper flex'>
                    {/* Empty left column for layout (4 columns) */}
                    <div className='hidden md:block md:w-4/12 col-padding' />

                    {/* Main content area (8 columns) */}
                    {text && (
                        <div
                            className='type-style-text-r mt-16 sm:w-8/12 md:w-5/12 col-padding rich-text'
                            dangerouslySetInnerHTML={{ __html: text }}/>
                    )}
                    {text && (
                        <div
                            className='hidden md:block mt-16 md:w-3/12 col-padding'/>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default RichText;
